import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public save(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  public get(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  public remove(key: string): void {
    return sessionStorage.removeItem(key);
  }

  public clear(): void {
    return sessionStorage.clear();
  }
}
